export default class VariantCharacterGroup {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new VariantCharacterGroup(json);
  }
}
